import React, { useState } from 'react';
import apiService from 'services/apiService';
import { useAuth } from 'hooks/useAuth';
import Modal from 'components/Modal';
import { KeyRound } from 'lucide-react';

const ForcePasswordChangeModal = ({ isOpen }) => {
    const { refetchUser } = useAuth();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword.length < 6) {
            setError('Password must be at least 6 characters long.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        setIsSubmitting(true);
        try {
            await apiService.updatePassword(newPassword);
            // Refetch user to get passwordChangeRequired: false
            await refetchUser();
        } catch (err) {
            setError(err.message || 'An error occurred. Please try again.');
            setIsSubmitting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={() => {}} title="Update Your Password" isDismissible={false}>
            <div className="text-center">
                <KeyRound className="mx-auto h-12 w-12 text-[#16e2c3]" />
                <p className="mt-4 text-slate-300">
                    For your security, you must set a new password before continuing.
                </p>
            </div>
            <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                <div>
                    <label className="block mb-2 text-sm font-medium text-slate-300">New Password</label>
                    <input 
                        type="password" 
                        value={newPassword} 
                        onChange={e => setNewPassword(e.target.value)} 
                        required 
                        className="bg-slate-700 border border-slate-600 text-white text-sm rounded-lg block w-full p-2.5" 
                        placeholder="••••••••"
                    />
                </div>
                <div>
                    <label className="block mb-2 text-sm font-medium text-slate-300">Confirm New Password</label>
                    <input 
                        type="password" 
                        value={confirmPassword} 
                        onChange={e => setConfirmPassword(e.target.value)} 
                        required 
                        className="bg-slate-700 border border-slate-600 text-white text-sm rounded-lg block w-full p-2.5" 
                        placeholder="••••••••"
                    />
                </div>
                {error && <p className="text-red-400 text-sm text-center">{error}</p>}
                <div className="pt-4">
                    <button 
                        type="submit" 
                        disabled={isSubmitting}
                        className="w-full bg-[#16e2c3] text-black font-bold py-3 px-4 rounded-md hover:bg-opacity-80 transition-opacity disabled:opacity-50"
                    >
                        {isSubmitting ? 'Updating...' : 'Set New Password'}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default ForcePasswordChangeModal;
